'use client'
import React, { useState, useEffect } from 'react';
import styles from '../../../styles/components/QuickLinkBox.module.scss';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconArrowUp, IconEnvelope, IconHammer, IconPhone } from "../ui/icons";

interface QuickLinkBoxProps {
  // Falls Props benötigt werden, hier definieren.
}

export const QuickLinkBox: React.FC<QuickLinkBoxProps> = (props) => {
  const [showGoTop, setShowGoTop] = useState<boolean>(false);
  const [activeButton, setActiveButton] = useState<string | null>(null);
  const [clickCounts, setClickCounts] = useState<{ [key: string]: number }>({});
  const [lastClickedElementId, setLastClickedElementId] = useState<string>("");
  const [currentlyHoveredButton, setCurrentlyHoveredButton] = useState<string | null>(null);

  const handleTouchStart = (id: string, href: string) => (event: React.MouseEvent<HTMLAnchorElement>) => {
    let clickHistory = JSON.parse(sessionStorage.getItem('clickHistory') || '[]');

    clickHistory.push({ timestamp: new Date().getTime(), buttonId: id });

    if (clickHistory.length > 2) {
      clickHistory.shift();
    }

    sessionStorage.setItem('clickHistory', JSON.stringify(clickHistory));

    const latestClickedButton = clickHistory[clickHistory.length - 1].buttonId;
    const previousClickedButton = clickHistory.length === 2 ? clickHistory[0].buttonId : "None";

    if (previousClickedButton === id) {
      setClickCounts({});
      window.location.href = href;
    } else {
      const currentCount = clickCounts[id] || 0;
      const updatedCounts = { ...clickCounts, [id]: currentCount + 1 };

      setClickCounts(updatedCounts);

      if (currentCount === 0) {
        setActiveButton(id);

        setTimeout(() => {  
          let clickHistory = JSON.parse(sessionStorage.getItem('clickHistory') || '[]');
      
          if (clickHistory.length > 0) {
              let latestClickedButton = clickHistory[clickHistory.length - 1].buttonId;
              let latestClickedButtonTS = new Date(clickHistory[clickHistory.length - 1].timestamp).getTime();
             
              let previousClickedButton = (clickHistory.length > 1) ? clickHistory[clickHistory.length - 2].buttonId : "None";
              let previousClickedButtonTS = new Date(clickHistory[0].timestamp).getTime();
              
              // Calculate the time delta
              let calculatedTimeDelta = new Date().getTime() - latestClickedButtonTS;
          
              // When to automatically reset the Active Button
              if (calculatedTimeDelta >= 5000) {
                  setActiveButton(null);
                  updatedCounts[id] = 0;
                  setClickCounts(updatedCounts);
              } else if (latestClickedButton !== previousClickedButton) {
                  // Do nothing, condition is satisfied
              } else {
                  setActiveButton(null);
                  updatedCounts[id] = 0;
                  setClickCounts(updatedCounts);
              }
      
              // Update session storage after processing
              clickHistory.shift(); // Now shift the array
              sessionStorage.setItem('clickHistory', JSON.stringify(clickHistory));
          }
      }, 5000); // Reset active button after 5000 ms

        Object.keys(clickCounts).forEach(key => {
          updatedCounts[key] = key === id ? (clickCounts[key] || 0) + 1 : 0;
        });
      } else {
        window.location.href = href;
      }
    }
  };

  const handleVisibleButton = () => {
    setShowGoTop(window.pageYOffset > 50);
  };

  const handleScrollUp = () => {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    sessionStorage.setItem('clickHistory', '[]');
    window.addEventListener('scroll', handleVisibleButton);
    return () => {
      window.removeEventListener('scroll', handleVisibleButton);
    };
  }, []);

  return (
    <React.Fragment>
      <div className={styles.specialButtons}>
        <a id="services" onClick={handleTouchStart('services', '/services')} className={activeButton === 'services' ? styles.hovered : ''}>
          <IconHammer className={styles.theIconItself} />
         
          <i className="icon-katalog"></i> Dienstleistungen
        </a>
        <a id="phone" onClick={handleTouchStart('phone', 'tel:+43421272880')} className={activeButton === 'phone' ? styles.hovered : ''}>          
          <IconPhone className={styles.theIconItself} />
          jetzt Anrufen
        </a>
        <a id="contact" onClick={handleTouchStart('contact', 'mailto:office@putz-estrich.at')} className={activeButton === 'contact' ? styles.hovered : ''}>          
          <IconEnvelope className={styles.theIconItself} />
          EMail schreiben
        </a>
        <a
          href="#top"
          title="Nach Oben"
          className={`${styles.slideUp} ${showGoTop ? styles.showAnker : ''}`}
          onClick={handleScrollUp}
        >
          <IconArrowUp className={styles.theGoTopIcon} />
        </a>
      </div>
    </React.Fragment>
  );
};

export default QuickLinkBox;
// type TrowelIconProps = {
//   width?: number;
//   height?: number;
//   className?: string;
// };

// const TrowelIcon: React.FC<TrowelIconProps> = ({ width = 24, height = 24, className }) => {
//   return (
//     <svg
//       width={width}
//       height={height}
//       viewBox="0 0 200 200"
//       xmlns="http://www.w3.org/2000/svg"
//       className={className}
//     >
//       {/* Kellen-Symbol */}
//       <polygon points="40,130 100,70 160,130 140,150 100,110 60,150" fill="green" stroke="green" strokeWidth="4"/>
      
//       {/* Griff */}
//       <rect x="90" y="40" width="20" height="50" fill="green" stroke="green" strokeWidth="2"/>
//     </svg>
//   );
// };

// export default TrowelIcon;
